import React from 'react';
import Layout from '../components/Layout';
import { PageProps } from '../App';

const PoliticaPrivacidadePage: React.FC<PageProps> = ({ darkMode, toggleDarkMode }) => {
  return (
    <Layout darkMode={darkMode} toggleDarkMode={toggleDarkMode}>
      <div className="bg-white dark:bg-gray-900 min-h-screen">
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-lupa-orange/10 to-lupa-yellow/10 dark:from-lupa-orange/5 dark:to-lupa-yellow/5 py-20">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-lupa-purple dark:text-white mb-6">
              Política de Privacidade
            </h1>
            <p className="text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
              Última atualização: 28 de agosto de 2025
            </p>
          </div>
        </section>

        {/* Content Section */}
        <section className="py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="prose prose-lg max-w-none dark:prose-invert">
              
              {/* Introdução */}
              <div className="mb-12">
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
                  A presente Política de Privacidade tem como propósito informar aos usuários ("usuário", 
                  "usuários", "titular" ou "você") dos serviços e website ("website" ou "site") da <strong>LUPA 
                  DATA</strong>, inscrita no CNPJ sob o n. 36.119.158/0001-22, com sede no SCN Quadra 1, Bloco 
                  F, Sala 1.608, Ed. América Office Tower, Asa Norte, Brasília/DF, CEP 70711-905, quais 
                  tipos de informações e dados pessoais são coletados, bem como esclarecer as 
                  condutas e procedimentos adotados pela LUPA DATA em relação ao armazenamento, 
                  uso, tratamento, compartilhamento e eliminação dos dados pessoais obtidos.
                </p>
              </div>

              {/* 1. Aplicação da Política de Privacidade */}
              <div className="mb-12">
                <h2 className="text-2xl font-bold text-lupa-purple dark:text-white mb-6 border-l-4 border-lupa-orange pl-4">
                  1. Aplicação da Política de Privacidade
                </h2>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                  A aceitação desta Política ocorre quando você acessa nosso site, aceita seus termos e 
                  usufrui dos serviços oferecidos, mesmo que gratuitamente. Isso significa que você 
                  declara ser maior de 18 (dezoito) anos e estar ciente e de acordo com a forma como 
                  utilizamos suas informações e dados pessoais, além dos dados referentes às empresas 
                  em que atua.
                </p>
                <div className="bg-lupa-orange/10 dark:bg-lupa-orange/5 border-l-4 border-lupa-orange p-4 rounded-r-lg mb-4">
                  <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
                    <strong>Importante:</strong> A LUPA DATA não comercializará, compartilhará ou fornecerá seus dados 
                    pessoais sem sua autorização expressa, exceto nas situações previstas nesta Política 
                    ou quando exigido por lei.
                  </p>
                </div>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
                  Nosso principal canal de comunicação para suporte, dúvidas, sugestões, contato 
                  comercial ou informações sobre produtos/serviços ou candidatar-se a vagas de 
                  emprego é o e-mail: <a href="mailto:Administração@lupadata.com" className="text-lupa-orange hover:text-lupa-orange-dark">Administração@lupadata.com</a>
                </p>
              </div>

              {/* 2. Coleta e Finalidades do Tratamento de Dados Pessoais */}
              <div className="mb-12">
                <h2 className="text-2xl font-bold text-lupa-purple dark:text-white mb-6 border-l-4 border-lupa-orange pl-4">
                  2. Coleta e Finalidades do Tratamento de Dados Pessoais
                </h2>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                  A coleta e o tratamento de dados pessoais são necessários para envio de notificações, 
                  comunicados e alterações técnicas no site e/ou nos serviços oferecidos. Para essas 
                  finalidades, a LUPA DATA poderá tratar os seguintes dados:
                </p>
                
                <div className="bg-gray-50 dark:bg-gray-800 p-6 rounded-lg mb-6">
                  <ul className="list-disc list-inside space-y-2 text-gray-700 dark:text-gray-300">
                    <li>Nome completo;</li>
                    <li>Números de telefone e/ou WhatsApp;</li>
                    <li>Endereço de e-mail.</li>
                  </ul>
                </div>

                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                  Os dados pessoais poderão ser tratados com as seguintes finalidades:
                </p>

                <div className="bg-gray-50 dark:bg-gray-800 p-6 rounded-lg">
                  <ul className="list-disc list-inside space-y-2 text-gray-700 dark:text-gray-300">
                    <li>possibilitar contato com o titular para relacionamento comercial;</li>
                    <li>elaboração de contratos comerciais e emissão de cobranças;</li>
                    <li>envio e fornecimento de produtos e serviços, gratuitos ou pagos;</li>
                    <li>desenvolvimento, testes, divulgação e promoção de produtos e serviços, personalizados ou não;</li>
                    <li>utilização em relatórios, estudos e materiais de comunicação;</li>
                    <li>manutenção de banco de dados de profissionais para futuros convites ou eventos;</li>
                    <li>viabilizar a prestação de serviços complementares, caso haja interesse do cliente;</li>
                    <li>cumprimento de obrigações legais ou regulatórias.</li>
                  </ul>
                </div>
              </div>

              {/* 3. Utilização de Cookies e Tecnologias Semelhantes */}
              <div className="mb-12">
                <h2 className="text-2xl font-bold text-lupa-purple dark:text-white mb-6 border-l-4 border-lupa-orange pl-4">
                  3. Utilização de Cookies e Tecnologias Semelhantes
                </h2>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-6">
                  Nosso site utiliza cookies e outras tecnologias de rastreamento para melhorar sua 
                  experiência de navegação, analisar o tráfego do site, personalizar conteúdo e anúncios, 
                  e entender de que forma você interage com nossos serviços.
                </p>

                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                  Utilizamos diferentes tipos de cookies:
                </p>

                <div className="grid md:grid-cols-2 gap-6 mb-6">
                  <div className="bg-gray-50 dark:bg-gray-800 p-6 rounded-lg">
                    <h3 className="text-lg font-semibold text-lupa-orange mb-3">Cookies Necessários</h3>
                    <p className="text-gray-700 dark:text-gray-300 text-sm">
                      Essenciais para o funcionamento básico do site, permitindo navegação, acesso a áreas 
                      seguras e funcionalidades essenciais. Não requerem seu consentimento.
                    </p>
                  </div>
                  
                  <div className="bg-gray-50 dark:bg-gray-800 p-6 rounded-lg">
                    <h3 className="text-lg font-semibold text-lupa-orange mb-3">Cookies de Desempenho/Analíticos</h3>
                    <p className="text-gray-700 dark:text-gray-300 text-sm">
                      Coletam informações sobre como você utiliza nosso site (páginas visitadas, tempo de 
                      permanência, erros, etc.) para que possamos aprimorar a performance e a usabilidade.
                    </p>
                  </div>
                  
                  <div className="bg-gray-50 dark:bg-gray-800 p-6 rounded-lg">
                    <h3 className="text-lg font-semibold text-lupa-orange mb-3">Cookies de Funcionalidade</h3>
                    <p className="text-gray-700 dark:text-gray-300 text-sm">
                      Permitem que o site se lembre de suas escolhas (nome de usuário, idioma ou região) 
                      e ofereça recursos aprimorados e mais personalizados.
                    </p>
                  </div>
                  
                  <div className="bg-gray-50 dark:bg-gray-800 p-6 rounded-lg">
                    <h3 className="text-lg font-semibold text-lupa-orange mb-3">Cookies de Marketing/Publicidade</h3>
                    <p className="text-gray-700 dark:text-gray-300 text-sm">
                      Utilizados para fornecer anúncios mais relevantes para você e seus interesses, bem 
                      como para limitar o número de vezes que você vê um anúncio e medir a eficácia das campanhas publicitárias.
                    </p>
                  </div>
                </div>

                <div className="bg-lupa-orange/10 dark:bg-lupa-orange/5 border-l-4 border-lupa-orange p-4 rounded-r-lg">
                  <h3 className="text-lg font-semibold text-lupa-purple dark:text-white mb-2">Gerenciamento de Cookies</h3>
                  <p className="text-gray-700 dark:text-gray-300 text-sm leading-relaxed">
                    Ao acessar nosso site pela primeira vez, você será solicitado a fornecer seu consentimento 
                    para o uso de cookies não essenciais por meio de um banner de consentimento de cookies. 
                    Você terá a opção de aceitar ou recusar diferentes categorias de cookies. A qualquer momento, 
                    você poderá revisar e alterar suas preferências de cookies acessando as configurações em 
                    nosso site ou diretamente nas configurações do seu navegador (Google Chrome, Mozilla Firefox, 
                    Microsoft Edge, Safari, etc.). Bloquear certos tipos de cookies pode afetar sua experiência 
                    de navegação e a funcionalidade de algumas partes do nosso site.
                  </p>
                </div>
              </div>

              {/* 4. Links para Websites de Terceiros */}
              <div className="mb-12">
                <h2 className="text-2xl font-bold text-lupa-purple dark:text-white mb-6 border-l-4 border-lupa-orange pl-4">
                  4. Links para Websites de Terceiros
                </h2>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
                  Nosso website pode conter links para páginas de terceiros, incluindo, mas não se 
                  limitando a: redes sociais, parceiros e anunciantes. A LUPA DATA não se responsabiliza 
                  pelo conteúdo, práticas de privacidade ou políticas de segurança desses sites. A 
                  presente política de privacidade aplica-se exclusivamente aos dados tratados pela 
                  LUPA DATA. Recomendamos que você consulte as políticas de privacidade de qualquer 
                  site de terceiros antes de fornecer quaisquer dados pessoais.
                </p>
              </div>

              {/* 5. Segurança e Sigilo dos Dados */}
              <div className="mb-12">
                <h2 className="text-2xl font-bold text-lupa-purple dark:text-white mb-6 border-l-4 border-lupa-orange pl-4">
                  5. Segurança e Sigilo dos Dados
                </h2>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                  A LUPA DATA adota medidas técnicas e administrativas rigorosas, continuamente 
                  revisadas e aprimoradas, para proteger os dados pessoais contra acessos não 
                  autorizados, destruição, perda, alteração, comunicação indevida ou qualquer forma de 
                  tratamento inadequado ou ilícito. Nossas práticas de segurança incluem:
                </p>

                <div className="bg-gray-50 dark:bg-gray-800 p-6 rounded-lg mb-4">
                  <ul className="list-disc list-inside space-y-2 text-gray-700 dark:text-gray-300">
                    <li>Controles de acesso físico e lógico restritos;</li>
                    <li>Uso de criptografia para dados em trânsito e em repouso, quando aplicável;</li>
                    <li>Implementação de firewalls e sistemas de detecção de intrusão;</li>
                    <li>Realização de backups periódicos;</li>
                    <li>Treinamento contínuo de nossa equipe sobre as melhores práticas de segurança da informação e privacidade de dados.</li>
                  </ul>
                </div>

                <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
                  Apesar de nossos esforços contínuos, é importante ressaltar que nenhuma transmissão 
                  de dados pela internet é 100% segura. Contamos com sua colaboração para manter a 
                  segurança de seus dados, protegendo suas credenciais de acesso e reportando 
                  qualquer atividade suspeita.
                </p>
              </div>

              {/* 6. Compartilhamento de Dados com Terceiros */}
              <div className="mb-12">
                <h2 className="text-2xl font-bold text-lupa-purple dark:text-white mb-6 border-l-4 border-lupa-orange pl-4">
                  6. Compartilhamento de Dados com Terceiros
                </h2>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                  Os dados pessoais coletados pela LUPA DATA poderão ser compartilhados com 
                  terceiros apenas nas seguintes condições e sempre com o propósito de viabilizar a 
                  prestação de nossos serviços ou o cumprimento de obrigações:
                </p>

                <div className="space-y-6">
                  <div className="bg-gray-50 dark:bg-gray-800 p-6 rounded-lg">
                    <h3 className="text-lg font-semibold text-lupa-orange mb-3">Operadores de Serviços</h3>
                    <p className="text-gray-700 dark:text-gray-300 text-sm leading-relaxed">
                      Com empresas que nos fornecem serviços essenciais para a operação do nosso website 
                      e sistemas (ex: provedores de hospedagem, plataformas de e-mail marketing, ferramentas 
                      de análise de dados, processadores de pagamento). Esses operadores atuam estritamente 
                      sob nossas instruções e são contratualmente obrigados a proteger seus dados.
                    </p>
                  </div>

                  <div className="bg-gray-50 dark:bg-gray-800 p-6 rounded-lg">
                    <h3 className="text-lg font-semibold text-lupa-orange mb-3">Parceiros Comerciais</h3>
                    <p className="text-gray-700 dark:text-gray-300 text-sm leading-relaxed">
                      No caso de aquisição de produtos ou soluções que envolvam a participação de parceiros, 
                      os dados poderão ser compartilhados para a execução contratual ou para a prestação 
                      dos serviços complementares solicitados.
                    </p>
                  </div>

                  <div className="bg-gray-50 dark:bg-gray-800 p-6 rounded-lg">
                    <h3 className="text-lg font-semibold text-lupa-orange mb-3">Autoridades Legais e Governamentais</h3>
                    <p className="text-gray-700 dark:text-gray-300 text-sm leading-relaxed">
                      Informações pessoais poderão ser fornecidas a autoridades competentes (judiciais, 
                      administrativas ou regulatórias) quando necessário para cumprir obrigações legais, 
                      regulatórias, ordens judiciais, investigações ou solicitações governamentais.
                    </p>
                  </div>

                  <div className="bg-gray-50 dark:bg-gray-800 p-6 rounded-lg">
                    <h3 className="text-lg font-semibold text-lupa-orange mb-3">Reorganizações Societárias</h3>
                    <p className="text-gray-700 dark:text-gray-300 text-sm leading-relaxed">
                      Em caso de fusão, aquisição, venda de ativos ou outras reorganizações societárias, 
                      seus dados pessoais poderão ser transferidos como parte do negócio, garantindo-se 
                      que a nova entidade continue a respeitar esta Política de Privacidade ou uma política 
                      com nível de proteção equivalente.
                    </p>
                  </div>
                </div>

                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mt-4">
                  A LUPA DATA exige que todos os terceiros com quem compartilha dados pessoais 
                  adotem padrões de segurança e privacidade compatíveis com esta Política e com a LGPD.
                </p>
              </div>

              {/* 7. Direitos do Titular dos Dados */}
              <div className="mb-12">
                <h2 className="text-2xl font-bold text-lupa-purple dark:text-white mb-6 border-l-4 border-lupa-orange pl-4">
                  7. Direitos do Titular dos Dados
                </h2>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                  De acordo com a Lei Geral de Proteção de Dados (LGPD – Lei nº 13.709/2018), você, 
                  como titular dos dados pessoais, possui os seguintes direitos, que podem ser exercidos 
                  a qualquer momento, mediante requisição através do e-mail: 
                  <a href="mailto:Administração@lupadata.com" className="text-lupa-orange hover:text-lupa-orange-dark ml-1">Administração@lupadata.com</a>
                </p>

                <div className="grid md:grid-cols-2 gap-4">
                  <div className="bg-gray-50 dark:bg-gray-800 p-4 rounded-lg">
                    <h4 className="font-semibold text-lupa-orange mb-2">1. Confirmação da existência de tratamento</h4>
                    <p className="text-gray-700 dark:text-gray-300 text-sm">Obter a confirmação se tratamos ou não seus dados pessoais.</p>
                  </div>

                  <div className="bg-gray-50 dark:bg-gray-800 p-4 rounded-lg">
                    <h4 className="font-semibold text-lupa-orange mb-2">2. Acesso aos dados</h4>
                    <p className="text-gray-700 dark:text-gray-300 text-sm">Acessar os dados pessoais que mantemos sobre você.</p>
                  </div>

                  <div className="bg-gray-50 dark:bg-gray-800 p-4 rounded-lg">
                    <h4 className="font-semibold text-lupa-orange mb-2">3. Correção de dados</h4>
                    <p className="text-gray-700 dark:text-gray-300 text-sm">Solicitar a retificação de dados incompletos, inexatos ou desatualizados.</p>
                  </div>

                  <div className="bg-gray-50 dark:bg-gray-800 p-4 rounded-lg">
                    <h4 className="font-semibold text-lupa-orange mb-2">4. Anonimização, bloqueio ou eliminação</h4>
                    <p className="text-gray-700 dark:text-gray-300 text-sm">Solicitar medidas em relação a dados desnecessários, excessivos ou tratados em desconformidade com a LGPD.</p>
                  </div>

                  <div className="bg-gray-50 dark:bg-gray-800 p-4 rounded-lg">
                    <h4 className="font-semibold text-lupa-orange mb-2">5. Portabilidade dos dados</h4>
                    <p className="text-gray-700 dark:text-gray-300 text-sm">Receber seus dados em formato estruturado e interoperável para transferência.</p>
                  </div>

                  <div className="bg-gray-50 dark:bg-gray-800 p-4 rounded-lg">
                    <h4 className="font-semibold text-lupa-orange mb-2">6. Eliminação dos dados</h4>
                    <p className="text-gray-700 dark:text-gray-300 text-sm">Solicitar a exclusão de dados cujo tratamento se baseou no seu consentimento.</p>
                  </div>

                  <div className="bg-gray-50 dark:bg-gray-800 p-4 rounded-lg">
                    <h4 className="font-semibold text-lupa-orange mb-2">7. Informação sobre compartilhamento</h4>
                    <p className="text-gray-700 dark:text-gray-300 text-sm">Ser informado sobre com quem seus dados foram compartilhados.</p>
                  </div>

                  <div className="bg-gray-50 dark:bg-gray-800 p-4 rounded-lg">
                    <h4 className="font-semibold text-lupa-orange mb-2">8. Informação sobre consentimento</h4>
                    <p className="text-gray-700 dark:text-gray-300 text-sm">Esclarecer sobre as implicações de não dar seu consentimento.</p>
                  </div>

                  <div className="bg-gray-50 dark:bg-gray-800 p-4 rounded-lg">
                    <h4 className="font-semibold text-lupa-orange mb-2">9. Revogação do consentimento</h4>
                    <p className="text-gray-700 dark:text-gray-300 text-sm">Retirar seu consentimento para o tratamento de dados a qualquer momento.</p>
                  </div>

                  <div className="bg-gray-50 dark:bg-gray-800 p-4 rounded-lg">
                    <h4 className="font-semibold text-lupa-orange mb-2">10. Oposição ao tratamento</h4>
                    <p className="text-gray-700 dark:text-gray-300 text-sm">Opor-se ao tratamento quando houver descumprimento à LGPD.</p>
                  </div>

                  <div className="bg-gray-50 dark:bg-gray-800 p-4 rounded-lg md:col-span-2">
                    <h4 className="font-semibold text-lupa-orange mb-2">11. Revisão de decisões automatizadas</h4>
                    <p className="text-gray-700 dark:text-gray-300 text-sm">Solicitar a revisão de decisões que afetem seus interesses e que foram tomadas por algoritmos, incluindo o perfilamento.</p>
                  </div>
                </div>

                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mt-4">
                  Atenderemos às suas requisições com a máxima agilidade e transparência, dentro dos 
                  prazos estabelecidos pela LGPD. Antes de processar sua solicitação, poderemos 
                  solicitar informações adicionais para confirmar sua identidade e garantir que a 
                  solicitação seja legítima.
                </p>
              </div>

              {/* 8. Retenção, Alteração e Eliminação de Dados */}
              <div className="mb-12">
                <h2 className="text-2xl font-bold text-lupa-purple dark:text-white mb-6 border-l-4 border-lupa-orange pl-4">
                  8. Retenção, Alteração e Eliminação de Dados
                </h2>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                  A LUPA DATA manterá seus dados pessoais apenas pelo período estritamente 
                  necessário para cumprir as finalidades para as quais foram coletados, respeitando os 
                  prazos legais e regulatórios aplicáveis.
                </p>

                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                  Os critérios para determinação do período de retenção incluem:
                </p>

                <div className="grid md:grid-cols-2 gap-6 mb-6">
                  <div className="bg-gray-50 dark:bg-gray-800 p-6 rounded-lg">
                    <h3 className="text-lg font-semibold text-lupa-orange mb-3">Finalidade do Tratamento</h3>
                    <p className="text-gray-700 dark:text-gray-300 text-sm">
                      O tempo necessário para cumprir o objetivo pelo qual os dados foram coletados 
                      (ex: manutenção de contrato ativo, duração da campanha de marketing).
                    </p>
                  </div>
                  
                  <div className="bg-gray-50 dark:bg-gray-800 p-6 rounded-lg">
                    <h3 className="text-lg font-semibold text-lupa-orange mb-3">Obrigações Legais ou Regulatórias</h3>
                    <p className="text-gray-700 dark:text-gray-300 text-sm">
                      Prazos de retenção exigidos por leis (ex: fiscais, trabalhistas, do consumidor).
                    </p>
                  </div>
                  
                  <div className="bg-gray-50 dark:bg-gray-800 p-6 rounded-lg">
                    <h3 className="text-lg font-semibold text-lupa-orange mb-3">Interesses Legítimos</h3>
                    <p className="text-gray-700 dark:text-gray-300 text-sm">
                      Períodos necessários para a proteção dos legítimos interesses da LUPA DATA, 
                      como defesa em processos judiciais ou administrativos.
                    </p>
                  </div>
                  
                  <div className="bg-gray-50 dark:bg-gray-800 p-6 rounded-lg">
                    <h3 className="text-lg font-semibold text-lupa-orange mb-3">Consentimento</h3>
                    <p className="text-gray-700 dark:text-gray-300 text-sm">
                      Enquanto o consentimento for mantido pelo titular para as finalidades específicas.
                    </p>
                  </div>
                </div>

                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                  Dados anonimizados, que não permitem a identificação de um indivíduo, poderão ser 
                  mantidos por prazo indeterminado para fins estatísticos ou de pesquisa.
                </p>

                <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
                  A eliminação de dados, quando solicitada ou quando o período de retenção expira, será 
                  realizada de forma segura, impossibilitando a recuperação das informações. É 
                  importante ressaltar que a eliminação de certos dados poderá inviabilizar a 
                  continuidade da prestação de serviços por parte da LUPA DATA.
                </p>
              </div>

              {/* 9. Transferência Internacional de Dados */}
              <div className="mb-12">
                <h2 className="text-2xl font-bold text-lupa-purple dark:text-white mb-6 border-l-4 border-lupa-orange pl-4">
                  9. Transferência Internacional de Dados
                </h2>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                  A LUPA DATA poderá, em algumas situações, realizar transferências internacionais de 
                  dados pessoais, por exemplo, ao utilizar serviços de provedores de nuvem ou 
                  ferramentas de software que possuam servidores localizados fora do Brasil.
                </p>

                <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
                  Nessas situações, a LUPA DATA se compromete a adotar medidas contratuais e 
                  técnicas adequadas para garantir a segurança e a privacidade dos seus dados, em 
                  conformidade com o Art. 33 da LGPD. As transferências serão realizadas apenas para 
                  países ou organismos internacionais que proporcionem um grau de proteção de dados 
                  pessoais adequado, ou mediante a adoção de salvaguardas como cláusulas contratuais 
                  padrão, normas corporativas globais ou outros mecanismos aprovados pela Autoridade 
                  Nacional de Proteção de Dados (ANPD).
                </p>
              </div>

              {/* 10. Atualizações desta Política */}
              <div className="mb-12">
                <h2 className="text-2xl font-bold text-lupa-purple dark:text-white mb-6 border-l-4 border-lupa-orange pl-4">
                  10. Atualizações desta Política
                </h2>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
                  Esta Política de Privacidade poderá ser atualizada periodicamente para refletir 
                  mudanças em nossas práticas de privacidade, alterações na legislação aplicável ou em 
                  nossos serviços. Sempre que houver modificações substanciais, a LUPA DATA divulgará 
                  a atualização em seu website, indicando a data da última modificação no início do 
                  documento. Recomendamos que você revise este documento periodicamente para se 
                  manter informado sobre como protegemos suas informações.
                </p>
              </div>

              {/* 11. Foro */}
              <div className="mb-12">
                <h2 className="text-2xl font-bold text-lupa-purple dark:text-white mb-6 border-l-4 border-lupa-orange pl-4">
                  11. Foro
                </h2>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
                  Fica eleito o Foro da Circunscrição Especial Judiciária de Brasília/DF para resolver 
                  quaisquer conflitos relacionados a esta Política, salvo disposições legais específicas 
                  sobre competência.
                </p>
              </div>

              {/* 12. Encarregado de Proteção de Dados (DPO) e Contato */}
              <div className="mb-12">
                <h2 className="text-2xl font-bold text-lupa-purple dark:text-white mb-6 border-l-4 border-lupa-orange pl-4">
                  12. Encarregado de Proteção de Dados (DPO) e Contato
                </h2>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                  Para quaisquer dúvidas, sugestões ou solicitações relacionadas a esta Política de 
                  Privacidade ou ao tratamento de seus dados pessoais pela LUPA DATA, por favor, entre 
                  em contato com a Lupa Data através desse e-mail:
                </p>
                
                <div className="bg-lupa-orange/10 dark:bg-lupa-orange/5 border border-lupa-orange/20 p-6 rounded-lg text-center">
                  <p className="text-lg font-semibold text-lupa-orange mb-2">E-mail de Contato</p>
                  <a href="mailto:administração@lupadata.com" className="text-xl font-bold text-lupa-purple dark:text-white hover:text-lupa-orange">
                    administração@lupadata.com
                  </a>
                </div>
              </div>

            </div>
          </div>
        </section>
      </div>
    </Layout>
  );
};

export default PoliticaPrivacidadePage;

